import { faPiggyBank as fasPiggyBank } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import React from "react";

export interface ProductPromoTexts {
	smallCalcText?: React.ReactNode;
	listingDesktopText?: React.ReactNode;
	listingMobileText?: React.ReactNode;
	listingIcon?: IconDefinition;
}

export const MARKETING_PRODUCT_PROMO_TEXT: Record<string, ProductPromoTexts> = {
	"eco-plus-five-year-free": {
		smallCalcText: <strong>5 évig ingyenes, Gold kártyával</strong>,
		listingDesktopText: (
			<>
				<strong>ONLINE</strong> bankszámla nyitás, <strong>5 évig ingyenes</strong>
			</>
		),
		listingMobileText: <strong>5 évig ingyenes</strong>,
		listingIcon: fasPiggyBank,
	},
	"two-years-free": {
		smallCalcText: <strong>2 évig ingyenes</strong>,
	},
	"three-years-free": {
		smallCalcText: <strong>3 évig ingyenes</strong>,
	},
};

export function getPromoText(cssRule: string): ProductPromoTexts {
	let promoText: ProductPromoTexts = {};
	cssRule.split(" ").forEach((rule) => {
		if (MARKETING_PRODUCT_PROMO_TEXT[rule]) {
			promoText = MARKETING_PRODUCT_PROMO_TEXT[rule];
		}
	});

	return promoText;
}
